import { Observable } from 'rxjs';
import { LazyLentaBootstrapCSRService } from './services/lazy-lenta-bootstrap.csr.service';
import { lazyService } from '@lentau/ui-kit/core/helpers/lazy-service';

export const LazyLoadLentaBootstrap: () => Observable<LazyLentaBootstrapCSRService> = () =>
  lazyService(() => import('./services/lazy-lenta-bootstrap.csr.service').then((m) => m.LazyLentaBootstrapCSRService));
